import { useEffect }               from 'react';
import { store }                   from 'index';
import { sessionDurationTopLimit } from './session_limits'
import { 
    LOG_OUT_SAGA, 
    SET_SESSION_DURATION
}                                  from 'actions';
import { objType }                 from 'types';


export const useCountSessionDuration = (sessionState: objType) => {

     // count session duration

     useEffect(() => {

        const { sessionDuration } = sessionState;

        if ( sessionDuration > sessionDurationTopLimit ) {
            return
        }

        const count = setInterval(() => {
          const next = sessionDuration + 1;
          store.dispatch(SET_SESSION_DURATION(next));
          try {
            localStorage.setItem('sessionDuration', String(next));
          } catch {}
        }, 1000); 
    
        return () => {
          clearInterval(count);
        };

    }, [sessionState]);


    
    // log user out after 12 session duration limit reached
    // DISABLED: Users should never be kicked out
    // useEffect(() => {
    //     
    //     const { sessionDuration } = sessionState;
    //
    //     if ( sessionDuration > sessionDurationTopLimit ) {
    //         try { localStorage.setItem('sessionDuration', String(sessionDuration)); } catch {}
    //         store.dispatch(LOG_OUT_SAGA())
    //     }
    //
    // }, [sessionState]);

}



